(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.documentElement;
    let resizeObserver = null;

    const updateAnnouncementBarHeight = () => {
      const bar = document.querySelector('.announcement-bar--sticky');
      if (!bar) {
        root.style.setProperty('--announcement-bar-height', '0px');
        return;
      }

      const section = bar.closest('.shopify-section') || bar;
      const height = Math.round(section.getBoundingClientRect().height);
      root.style.setProperty('--announcement-bar-height', `${height}px`);
    };

    const observeAnnouncementBar = () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }

      const bar = document.querySelector('.announcement-bar--sticky');
      if (!bar || typeof ResizeObserver === 'undefined') {
        updateAnnouncementBarHeight();
        return;
      }

      const section = bar.closest('.shopify-section') || bar;
      resizeObserver = new ResizeObserver(updateAnnouncementBarHeight);
      resizeObserver.observe(section);
      updateAnnouncementBarHeight();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAnnouncementBar, { once: true });
    } else {
      observeAnnouncementBar();
    }

    document.addEventListener('shopify:section:load', observeAnnouncementBar);
    document.addEventListener('shopify:section:unload', observeAnnouncementBar);
    document.addEventListener('shopify:section:reorder', observeAnnouncementBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
